import { match } from 'ts-pattern';
import { memoEval } from '@salsita-ai/platform-project-sdk/domain';
import { implementCustomExpressions } from '../__generated/implementation.js';
import { FenixVariant, TopColorCeramic, TopMaterial } from '../__generated/model/index.js';
import { BASE_PRICE_MAP_OTHER_CERAMIC, BASE_PRICE_MAP_OTHER_FENIX_BIRCH, BASE_PRICE_MAP_OTHER_FENIX_SOLID, BASE_PRICE_MAP_OTHER_OAK_30, BASE_PRICE_MAP_OTHER_OAK_40 } from '../data/prices.js';
// If the length of a table top is greater than this value, no legs of any type grow any further.
const TABLE_LENGTH_MORPH_CEILING = 2400;
const ALL_LENGTHS = [
    1600,
    1800,
    2000,
    2200,
    2400,
    2600,
    2800,
    3000
];
const ALL_WIDTHS = [
    800,
    900,
    1000,
    1100,
    1200,
    1300
];
const LENGTH_OPTIONS = ALL_LENGTHS.map((length)=>({
        value: length,
        label: `${length / 10} cm`
    }));
const WIDTH_OPTIONS = ALL_WIDTHS.map((width)=>({
        value: width,
        label: `${width / 10} cm`
    }));
export const topWithLengthAndWidthExpressions = implementCustomExpressions({
    TopWithLengthAndWidth: {
        $basePrice: memoEval((self)=>[
                self.fenixVariant,
                self.length,
                self.material,
                self.thickness,
                self.width
            ], (fenixVariant, length, material, thickness, width)=>{
            const priceMap = match(material).with(TopMaterial.SolidOak, ()=>thickness === 30 ? BASE_PRICE_MAP_OTHER_OAK_30 : BASE_PRICE_MAP_OTHER_OAK_40).with(TopMaterial.Ceramic, ()=>BASE_PRICE_MAP_OTHER_CERAMIC).with(TopMaterial.Fenix, ()=>fenixVariant === FenixVariant.Birch ? BASE_PRICE_MAP_OTHER_FENIX_BIRCH : BASE_PRICE_MAP_OTHER_FENIX_SOLID).exhaustive();
            return priceMap.get(length)?.get(width) ?? 0;
        }),
        $descriptionDimensions: (self)=>`${self.length / 10}x${self.width / 10}cm/${self.thickness}mm`,
        $lengthOptions: ()=>LENGTH_OPTIONS,
        $morphLength: (self)=>Math.min(self.length, TABLE_LENGTH_MORPH_CEILING),
        $repeatX: (self)=>{
            if (TopColorCeramic.is(self.color)) {
                return self.width / self.$ceramicRepeatRatio;
            }
            return self.length / self.$woodRepeatRatio;
        },
        $repeatY: (self)=>{
            if (TopColorCeramic.is(self.color)) {
                return self.length / self.$ceramicRepeatRatio;
            }
            return self.width / self.$woodRepeatRatio;
        },
        $widthOptions: ()=>WIDTH_OPTIONS
    }
});

//# sourceMappingURL=top-with-length-and-width.js.map